import { render, staticRenderFns } from "./BoxGenitorParte.vue?vue&type=template&id=03840d8a&"
import script from "./BoxGenitorParte.vue?vue&type=script&lang=js&"
export * from "./BoxGenitorParte.vue?vue&type=script&lang=js&"
import style0 from "./BoxGenitorParte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports